<template>
    <div class="book-now-main">
        <div class="service">
           <div class="service-center" ref="service">
                    <div class="service-left" :class="{'animateX':isAnimateService}">
                        <div class="img1" :class="{'banner-fade-in':isAnimateService}"><img loading="lazy"  :src="serviceInfo.img1" alt=""></div>
                            <div class="img2" :class="{'banner-fade-in':isAnimateService}">
                            <img loading="lazy"  class="img2-one" :src="serviceInfo.img2" alt="">
                            <img loading="lazy"  class="img2-two" :src="serviceInfo.img3" alt="">
                        </div>
                    </div>
                    <div class="service-right" :class="{'animateRight':isAnimateService}">
                        <div class="right-title">{{serviceInfo.title}}</div>
                        <div class="right-content">
                        <div class="li" v-for="item in serviceInfo.descList" :key="item.id">
                            <span></span><div class="li-desc">{{ item.desc }}</div>
                        </div>
                    </div>
                </div>
           </div>
        </div>
        <div class="provide-you-with" ref="provide">
            <div class="title">{{provideInfo.title}}</div>
            <img loading="lazy"  :src="provideInfo.img" alt="" :class="{'banner-fade-in':isAnimateService}">
            <div class="all-desc" :class="{'animate':isAnimate}">
                <div class="desc" v-for="item in provideInfo.descList" :key="item.id">
                    <div class="num">{{item.id}}</div>
                    <div class="desc-content">{{item.desc}}</div>
                </div>
            </div>
        </div>
        <fromMoveNow></fromMoveNow>
    </div>
</template>

<script>
import service from '/js/bookNow/service.js'
import provide from '/js/bookNow/provide.js'
// import {startTimeChangeWay,startTimeRulesEvent,endTimeRulesEvent} from '../../../js/fromRules/fromRulesWay.js';
import fromMoveNow from './fromMoveNow.vue'
export default {
    components:{
        fromMoveNow
    },
    data() {
        return {
            serviceInfo:service.serviceInfo,
            provideInfo:provide.provideInfo,
            isAnimateService:false,
            isAnimate:false
            // pickerOptions: {
            //     disabledDate(time) {
            //         return startTimeRulesEvent(time)
            //     }
            // },
            // isInputMask:true,
        };
    },
    mounted(){
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                // 当 .Popular-products 进入视口时触发动画
                if (entry.isIntersecting) {
                    if (entry.target === this.$refs.provide) {
                    this.isAnimate = true;
                    } else if (entry.target === this.$refs.service) {
                    this.isAnimateService = true;
                    }
                    observer.unobserve(entry.target); // 只触发一次
                }
            });
        }, { threshold: 0.1 }); // 触发时，至少 10% 的元素进入视口

        // 开始观察
        observer.observe(this.$refs.provide);
        observer.observe(this.$refs.service);

    },
    // 结束时间限制
    //  computed: {
    //     departurePickerOptions() {
    //         return {
    //             disabledDate: (time) => {
    //                 return endTimeRulesEvent(this.userInfo.arrivalDate,time)

    //             }
    //         };
    //     }
    // },
    methods: {
    }
};
</script>
<!--//test/-->
<style scoped lang="scss">
@import '/style/pc/bookNow/bookNow.scss';
@import '/style/phone/bookNow/bookNow.scss';
@import '/style/pc/common/fadeIn.scss';
@import '/style/pc/common/animate.scss';
@import '/style/pc/common/animateX.scss';
@import '/style/pc/common/animateRight.scss';
</style>
